import { useIntl } from 'react-intl';

export const CAMPAIGN_PLAN_COLUMN_VISIBILITY_KEY = 'campaignPlanList';

// Assumed (ticket does not define it): every column except name, leading and actions can be hidden.
export const CAMPAIGN_PLAN_HIDEABLE_COLUMN_IDS = ['status', 'duration', 'lastUpdate', 'budgetSpend'];

/** Labels of the hideable columns plus the name entry shown (always checked) in the column visibility menu. */
export function useCampaignPlanColumnLabels(): Record<string, string> {
  const { formatMessage } = useIntl();

  return {
    budgetSpend: formatMessage({ defaultMessage: 'Budget Spent', id: 'campaignPlans.list.toolbar.budget' }),
    duration: formatMessage({ defaultMessage: 'Duration', id: 'campaignPlans.list.toolbar.duration' }),
    lastUpdate: formatMessage({ defaultMessage: 'Last Update', id: 'campaignPlans.list.toolbar.date' }),
    name: formatMessage({ defaultMessage: 'Campaign Plan name', id: 'campaignPlans.list.columnVisibility.name' }),
    status: formatMessage({ defaultMessage: 'Status', id: 'campaignPlans.list.toolbar.status' })
  };
}
